var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('search-query-input',{ref:"queryInput",attrs:{"id":_vm.id,"placeholder":_vm.placeholder},on:{"change":function($event){return _vm.$emit('change')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }